var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-default',{staticClass:"al-about-me",attrs:{"section":_vm.theme.ui.about}},[_c('base-card',[_c('base-text',{attrs:{"content":_vm.profile.about.content}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }